import {UiSchema} from "../cody-wizard/ui/ui-schema";
import {AnyRule, PropMapping} from "./rule-definitions";

export interface ButtonConfig {
  variant?: "text" | "outlined" | "contained",
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
  disabled?: boolean,
  style?: object,
  hidden?: boolean,
  icon?: React.ReactNode,
  label?: string,
  endIcon?: React.ReactNode,
  'variant:expr'?: string,
  'color:expr'?: string,
  'disabled:expr'?: string,
  'style:expr'?: string,
  'hidden:expr'?: string,
  'icon:expr'?: string,
  'label:expr'?: string,
  'endIcon:expr'?: string,
}

export interface Action {
  type: "command" | "link" | "rules";
  description?: string;
  position: "top-right" | "bottom-left" | "bottom-center" | "bottom-right";
  button: ButtonConfig;
}

export const isLinkAction = (action: Action): action is LinkAction => {
  return action.type === "link";
}

export const isCommandAction = (action: Action): action is CommandAction => {
  return (!action.type && (action as any).command) || action.type === "command";
}

export const isRulesAction = (action: Action): action is RulesAction => {
  return action.type === "rules";
}

export interface LinkAction extends Action {
  pageLink?: string | {page: string; mapping: Record<string, string>};
  href?: string;
}

export interface CommandAction extends Action {
  command: string;
  uiSchema?: UiSchema,
  connectTo?: string,
  directSubmit?: boolean,
  forceSchema?: boolean,
  data?: string | string[] | PropMapping | PropMapping[];
}

export interface RulesAction extends Action {
  rules: AnyRule[];
}

export type ActionConfig = LinkAction | CommandAction | RulesAction;

